import { createBrowserRouter } from "react-router";

import RootLayout from "@/app/root-layout";

/** Wraps a `export default` route module into the shape React Router lazy expects. */
function route(load: () => Promise<{ default: React.ComponentType }>) {
  return async () => ({ Component: (await load()).default });
}

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    children: [
      {
        index: true,
        lazy: route(() => import("@/app/routes/landing")),
      },
      {
        lazy: route(() => import("@/app/routes/storefront-layout")),
        children: [
          { path: "home", lazy: route(() => import("@/app/routes/home")) },
          { path: "shop", lazy: route(() => import("@/app/routes/shop")) },
          { path: "cart", lazy: route(() => import("@/app/routes/cart")) },
          { path: "checkout", lazy: route(() => import("@/app/routes/checkout")) },
          { path: "login", lazy: route(() => import("@/app/routes/login")) },
          { path: "register", lazy: route(() => import("@/app/routes/register")) },
          { path: "orders", lazy: route(() => import("@/app/routes/orders")) },
          { path: "orders/:id", lazy: route(() => import("@/app/routes/order-detail")) },
          { path: "orders/:id/pay", lazy: route(() => import("@/app/routes/order-pay")) },
          { path: "products/:slug", lazy: route(() => import("@/app/routes/product")) },
          { path: "collections/:slug", lazy: route(() => import("@/app/routes/collection")) },
          { path: "policies/:type", lazy: route(() => import("@/app/routes/policy")) },
          { path: "*", lazy: route(() => import("@/app/routes/not-found")) },
        ],
      },
    ],
  },
]);
